import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import { positionsKey, requestPositionRoute } from '@features/positions';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';

type UseRequestPositionProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
};

export const useRequestPosition = ({
  setErrorText,
}: UseRequestPositionProps) => {
  const client = useQueryClient();

  const { mutate: requestPosition, isLoading: isRequestPositionLoading } =
    useMutation({
      mutationFn: (variables: {request_body: string}) =>
        axiosInstance
          .post(requestPositionRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data?.status === 200) {
          setErrorText('');
          client.invalidateQueries([positionsKey]);
          client.invalidateQueries([profileKey]);
        } else {
          setErrorText(data?.message ?? '');
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return { requestPosition, isRequestPositionLoading };
};
